import { useCallback, useEffect, useState } from 'react'

import { mapFromServer } from 'onboarding/components/widgets/public/forms/lnr/helpers/mapFromServer'
import { lnrChampionService } from 'onboarding/services/lnrChampionService'
import { TypedResult } from 'onboarding/types/result'
import { showErrorOnCatch } from 'onboarding/utils/errorResponse/showErrorOnCatch'
import { tryCatchAsync } from 'onboarding/utils/tryCatch'

import { getInitialLnRChampionForm } from '../helpers/getInitialLnRChampionForm'
import { mapToServer } from '../helpers/mapToServer'
import { TLNRChampion, TLNRChampionServer } from '../models'

export const useLNRChampion = (requestId: number) => {
  const [fetched, setFetched] = useState<TLNRChampion>(getInitialLnRChampionForm)
  const [isFetching, setIsFetching] = useState(true)
  const [isSaving, setIsSaving] = useState(false)

  const onSave = useCallback(async (payload: TLNRChampion) => {
    setIsSaving(true)
    const mapped = mapToServer(payload)
    const result: TypedResult<TLNRChampionServer> = await tryCatchAsync(
      payload.EntryId
        ? lnrChampionService.updateOne(payload.EntryId, {
            FirstName: mapped.FirstName,
            LastName: mapped.LastName,
            Email: mapped.Email,
            JobTitle: mapped.JobTitle,
            WorkPhone: mapped.WorkPhone,
            WorkPhone_Prefix: mapped.WorkPhone_Prefix,
            MobilePhone: mapped.MobilePhone,
            MobilePhone_Prefix: mapped.MobilePhone_Prefix,
          })
        : lnrChampionService.createOne(mapped)
    )
    if (!result.error) {
      setFetched(mapFromServer(result.data))
    }
    setIsSaving(false)

    return result
  }, [])

  useEffect(() => {
    const fetch = async () => {
      setIsFetching(true)
      const { data, error } = await tryCatchAsync(lnrChampionService.fetchOneByRequestId(requestId))
      if (error) {
        showErrorOnCatch(error)
        setFetched(getInitialLnRChampionForm)
      } else {
        setFetched(mapFromServer(data))
      }
      setIsFetching(false)
    }

    if (requestId) fetch()
  }, [requestId])

  return {
    fetched,
    isFetching,

    onSave,
    isSaving,
  }
}
